import { DriscollsBannerModule } from '@driscollsinc/application-banner-module-ui';
import { useAuth } from '@driscollsinc/login-module-ui';
import style from './Banner.module.scss';

const Banner = () => {
  const { authState } = useAuth();

  const env = window.config.API_ENV;

  if(!env) {
        console.error('API_ENV is not defined, Banner can not be loaded!');
        return null;
  }

  return (
    authState?.isAuthenticated && (
      <DriscollsBannerModule
        application="QMP"
        accessToken={authState.accessToken?.accessToken}
        currentLanguage="en"
        layout="stack"
        env={env}
        className={style.qmpBanner}
      />
    )
  );
};

export default Banner;